<template>
  <ms-dialog
    ref="dialog"
    :append-to-body="false"
    :width="dialogWidth"
    :title="$t('User.ChangePassword')"
    @close="onCloseProxy"
    @opened="onOpen"
  >
    <div
      class="container"
      ref="container"
    >
      <ms-form
        class="forget-password-form"
        @keyup.enter="onChangePassword"
      >
        <!-- Nhập mật khẩu -->
        <div class="row">
          <ms-text-field
            ref="password"
            :placeholder="$t('User.EnterPassword')"
            v-model="currentItem.password"
            show-password
            :allow-blank="false"
            @blur="onBlurPassword"
          >
            <template #prefix>
              <div class="input-prefix-icon">
                <img
                  :src="iconPassword?.src"
                  :width="iconPassword?.width"
                  :height="iconPassword?.height"
                >
              </div>
            </template>
          </ms-text-field>
        </div>
        <!-- Nhập mật khẩu mới -->
        <div class="row">
          <ms-text-field
            ref="newPassword"
            :placeholder="$t('User.EnterNewPassword')"
            v-model="currentItem.newPassword"
            @blur="onBlurNewPassword"
            show-password
            :allow-blank="false"
          >
            <template #prefix>
              <div class="input-prefix-icon">
                <img
                  :src="iconPassword?.src"
                  :width="iconPassword?.width"
                  :height="iconPassword?.height"
                >
              </div>
            </template>
          </ms-text-field>
        </div>
        <!-- Nhập lại mật khẩu -->
        <div class="row">
          <ms-text-field
            :placeholder="$t('User.ConfirmPassword')"
            v-model="currentItem.confirmPassword"
            @blur="onBlurPasswordConfirm"
            ref="confirmPassword"
            show-password
            :allow-blank="false"
          >
            <template #prefix>
              <div class="input-prefix-icon">
                <img
                  :src="iconPassword?.src"
                  :width="iconPassword?.width"
                  :height="iconPassword?.height"
                >
              </div>
            </template>
          </ms-text-field>
        </div>
        <!-- Button gửi yêu cầu -->
        <div class="row">
          <ms-button
            type="gradient"
            @click="onChangePassword"
          >
            {{ $t('User.ChangePassword') }}
          </ms-button>
        </div>
      </ms-form>
    </div>
  </ms-dialog>
</template>

<script>
import BaseDetailPopup from '@/views/base/base-detail-popup.vue'
import { getContextData, ContextDataKey } from '@/utils/context-data'
import { mapActions } from 'vuex'

export default {
  extends: BaseDetailPopup,

  data () {
    return {
      currentItem: {
        userName: getContextData(ContextDataKey.UserName),
        password: '',
        newPassword: '',
        confirmPassword: ''
      },
      dialogWidth: '400px',
      autoLoad: false,
      /**
       * icon mật khẩu
       */
      iconPassword: {
        src: require('@/assets/icons/svg/account/ic_password.svg'),
        width: 16,
        height: 16
      }
    }
  },

  methods: {
    ...mapActions('account', {
      changePassword: 'changePassword'
    }),

    getContainer () {
      return this.$refs.container
    },

    /**
     * @author PVThang
     * @description Gọi clearCustomError của tất cả các ref
     */
    clearCustomError () {
      const refs = Object.values(this.$refs)

      refs.forEach(ref => {
        if (typeof (ref.clearCustomError) === 'function') {
          ref.clearCustomError()
        }
      })
    },

    /**
     * @author PVThang
     * @description
     */
    onCloseProxy () {
      const me = this

      this.currentItem = {
        userName: getContextData(ContextDataKey.UserName),
        password: '',
        newPassword: '',
        confirmPassword: ''
      }
      me.clearCustomError()
    },

    /**
     * Xử lý khi open dialog
     */
    onOpen () {
      const me = this

      me.$refs.password.focus()
      me.clearCustomError()
    },

    /**
     * @author PVThang
     * @description xử lý đổi mật khẩu
     */
    onChangePassword () {
      const me = this

      me.clearCustomError()
      me.showMask()
      if (!me.validateForm()) {
        setTimeout(() => {
          me.hideMask()
        }, me.$enumeration.TimeShowMask.Default)
        me.onAfterHandleError()
        return
      }

      me.changePassword(me.currentItem).then(res => {
        if (!res?.IsSuccess) {
          me.onHandleError(res)
          me.onAfterHandleError()
        } else {
          me.$notify.showSuccess({
            message: me.$t('User.ChangePasswordSuccess')
          })
          me.doClose()
        }
      }).finally(() => {
        me.hideMask()
      })
    },

    /**
     * @author PVThang
     * @description validate dữ liệu
     */
    validateForm () {
      const me = this
      let result = true

      me.onBlurPassword()
      me.onBlurNewPassword()
      me.onBlurPasswordConfirm()

      Object.keys(me.$refs).forEach(key => {
        if (me.$refs[key]?.hasError) {
          result = false
        }
      })
      return result
    },

    /**
     * @author PVThang
     * @description Xử lý lỗi trả về từ server
     */
    onHandleError (res) {
      const me = this
      var errorCodes = res?.Data?.Status?.ErrorCode
      const invalidFieldEnumeration = me.$enumeration?.InvalidFieldEnumeration

      if (!Array.isArray(errorCodes)) {
        errorCodes = [errorCodes]
      }

      if (errorCodes.includes(invalidFieldEnumeration?.UserNameInvalid)) {
        me.$notify.showError({
          message: me.$t('User.HasErrorTryAgain')
        })
      }
      if (errorCodes.includes(invalidFieldEnumeration?.PasswordInvalid)) {
        me.$refs.password.setCustomError(me.$t('User.PasswordInvalid'))
      }
    },

    /**
     * @author PVThang
     * @description Xử lý sau khi có lỗi
     */
    onAfterHandleError () {
      const me = this
      const keys = Object.keys(me.$refs)

      for (let i = 0; i < keys.length; ++i) {
        if (me.$refs[keys[i]].hasError && typeof (me.$refs[keys[i]].focus) === 'function') {
          me.$refs[keys[i]].focus()
          break
        }
      }
    },

    /**
     * @author PVThang
     * @description xử lý sự kiện blur password
     */
    onBlurPassword () {
      const me = this

      me.$refs.password.clearCustomError()
      if (!me.currentItem?.password) {
        me.$refs.password.setCustomError(me.$t('User.NotAllowBlank'))
      }
    },

    /**
     * @author PVThang
     * @description xử lý sự kiện blur new password
     */
    onBlurNewPassword () {
      const me = this

      me.$refs.newPassword.clearCustomError()
      if (!me.currentItem?.newPassword) {
        me.$refs.newPassword.setCustomError(me.$t('User.NotAllowBlank'))
      }
      if (me.currentItem?.newPassword === me.currentItem?.confirmPassword) {
        me.$refs.confirmPassword.clearCustomError()
      }
    },

    /**
     * @author PVThang
     * @description xử lý sự kiện blur password-confirm
     */
    onBlurPasswordConfirm () {
      const me = this

      me.$refs.confirmPassword.clearCustomError()
      if (!me.currentItem?.confirmPassword) {
        me.$refs.confirmPassword.setCustomError(me.$t('User.NotAllowBlank'))
      } else if (me.currentItem?.newPassword !== me.currentItem?.confirmPassword) {
        me.$refs.confirmPassword.setCustomError(me.$t('User.PasswordConfirmNotDuplicate'))
      }
    }
  }

}
</script>

<style lang="scss" scoped>

@import "@/assets/scss/mixins/mixins";

.forget-password-form {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: left;
  text-align: left;

  .row {
    display: flex;
    justify-content: center;
    margin-top: 12px;
    width: 100%;

    > * {
        width: 100%;
    }

    .text-accent {
      width: auto;
      margin-top: 24px;
      color: $color-semantic-blue;
      cursor: pointer;
    }
  }

  .password-status {
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-column-gap: 4px;
    padding-top: 4px;

    > div {
      padding-top: 4px;
      @include caption();
      border-top: 2px solid $color-error;
      color: $color-error;
    }

    .valid {
      border-top: 2px solid $color-success;
      color: $color-success;
    }
  }

  .text-align-left {
    text-align: left;
  }

  .text-align-center {
    text-align: center;
  }

  .text-align-right {
    text-align: right;
  }

  .input-prefix-icon {
    width: 28px;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
